const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  profile ({ state, commit, rootState }, params) {
    return rootState.axios.get('/coin/v1frontend/coin-game/profile', { params })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
